import React, { useState } from "react"
import { TAttributeValue } from "types/Pages/ProductDelta"
import CustomSearchBar from "../components/CustomSearchBar"
import Utils from "Common/Utils"
import { SORT } from "Pages/GMS/Products/constants"
import ViewMoreButton from "Components/Common/components/ViewMoreButton"
import { debounce } from "lodash"

type MyProps = {
    attribute_values: TAttributeValue[]
    handleClick: (e: React.MouseEvent<HTMLButtonElement>, id: string, attributeValueName: string) => void
    selected: string[]
    loadAttributeValues: (query: string, page: number) => Promise<void>
    attributeValueCount: number | undefined
    page: number
    setPage: (newPage: number) => void
}

const AttributeValueList = ({ attribute_values, selected, handleClick, loadAttributeValues, attributeValueCount, page, setPage }: MyProps) => {
    const [search, setSearch] = useState<string>("")
    const [loadingAttributeValues, setLoadingAttributeValues] = useState<boolean>(false)

    const handleSearch = debounce(async (query: string) => {
        setLoadingAttributeValues(true)
        setSearch(query)
        setPage(1)
        await loadAttributeValues(query, 1)
        setLoadingAttributeValues(false);
    }, 500);

    const handleViewMoreButtonClick = () => {
        setPage(page + 1);
        loadAttributeValues(search, page + 1);
    };

    return (
        <div >
            {
                <div>
                    <CustomSearchBar
                        delay={200}
                        handleSearchChange={handleSearch}
                        placeholder="Search Attribute Values"
                        autoComplete="off"
                    />
                </div>
            }
            <div className={`tw-flex tw-flex-wrap tw-gap-2.5 tw-py-2`}>
                {
                    loadingAttributeValues ? <div>loading...</div> : attributeValueCount === 0 ? <div>No attribute values found</div> :
                        attribute_values?.sort(Utils.sortChoices(true, SORT.ASC, (item: TAttributeValue) => item.value, () => true))
                            .map((attrval) => (
                                <button
                                    key={attrval.id}
                                    onClick={(e) => handleClick(e, attrval.id, attrval.value)}
                                    className={`tw-bg-gray hover:tw-bg-lightgray tw-text-black tw-rounded tw-p-0.5 tw-px-2 tw-min-w-[50px] tw-text-center tw-text-xs ${selected.includes(attrval.id) && "tw-border tw-border-primary tw-text-primary"}`}>
                                    {attrval.value}
                                </button>
                            ))
                }
            </div>
            <ViewMoreButton condition={
                attributeValueCount && attribute_values?.length < attributeValueCount && !loadingAttributeValues
            } handleClick={handleViewMoreButtonClick} state={false} />
        </div>
    )
}

export default AttributeValueList